import { render } from "./pageNot.vue?vue&type=template&id=cbd4f650"
import script from "./pageNot.vue?vue&type=script&lang=js"
export * from "./pageNot.vue?vue&type=script&lang=js"

import "./pageNot.vue?vue&type=style&index=0&id=cbd4f650&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__